<script>
import WideIconTile from '@/components/WideIconTile'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import Separator from '@/components/Separator'
import StoresServices from '@/services/stores'
import DOMUtils from '@/utils/DOMUtils'
import EnvironmentUtils from '@/utils/environmentUtils'
import StringUtils from '@/utils/stringUtils'
import Fuse from 'fuse.js'

export default
{
    name: 'edit-stores-view',

    beforeRouteEnter (to, from, next)
    {
        next(vm =>
        {
            let tiles = vm.$el.querySelectorAll('.pop')
            

            tiles.forEach(tile =>
            {
                DOMUtils.animateCSS(tile, 'zoomIn', '0.4s')
            })
        })
    },

    created ()
    {
        const fuseOptions =
        {
            shouldSort: true,
            threshold: 0.5,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 1,
            keys:
            [
                'name'
            ]
        }

        StoresServices.fetchStores(EnvironmentUtils.cityId).then(async stores  =>
        {
            await this.$store.commit('stores/updateStoreList', stores)
        })

        this.fuse = new Fuse(this.stores, fuseOptions)
    },

    render () 
    {
        return (
            <div id='edit-stores-view'>
                <WideIconTile id='add-store' class='button-tile pop' on-click={this.onAddStoreClicked} title={ 'ajouter un nouveau commerce' }
                    icon={ require('@/assets/img/plus.svg') } inline-svg={true} />
                
                <div id='added-stores-card' class='pop'>
                    <FloatingLabelTextInput id='store-search-field' class='light-gray-style' type='text' placeholder='Rechercher un commerce'
                        icon={require('@/assets/img/magnifying-glass-thin.svg')} placeholder-disappear-on-text={true} v-model={this.storeSearchValue} />
                    
                    <div id='store-cards'>
                        {
                            this.displayedStores.map((store, i) =>
                            {
                                return (
                                    <div on-click={() => this.onStoreCardClicked(store)}>
                                        <Separator v-show={i > 0} />

                                        <div class='store-card'>
                                            <div class='store-card-information'>
                                                <img class='store-image' src={store.pictures[0] || require('@/assets/img/photo.svg')} />
                                                <div class='store-header'>
                                                    <p class='store-name'>{ store.name }</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        )
    },

    data () 
    {
        return {
            fuse: null,
            storeSearchValue: ''
        }
    },

    computed:
    {
        stores ()
        {
            return this.$store.state.stores.storeList.filter(s => s.cityId == EnvironmentUtils.cityId).sort((a, b) => a.name.localeCompare(b.name))
        },

        displayedStores ()
        {
            if (StringUtils.isEmptyString(this.storeSearchValue))
            {
                return this.stores
            }

            this.fuse.list = this.stores

            return this.fuse.search(this.storeSearchValue)
        }
    },

    mounted ()
    {
    },

    methods:
    {
        onAddStoreClicked ()
        {
            this.$router.push({ path: 'add', append: true })
        },

        async onStoreCardClicked (store)
        {
            this.$router.push({ path: 'update/' + store.id.toString(), append: true })
        }
    },

    components:
    {
        WideIconTile,
        FloatingLabelTextInput,
        Separator
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#edit-stores-view
{
    display: flex;
    flex-direction: column;
    padding: 0 3vw 0 3vw;
    margin-top: 12vw;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);

    .OnDesktop({
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
        margin-top: 2vw;
        margin-bottom: 0;
        padding-left: 10vw;
        padding-right: 10vw;
    });

    #add-store
    {
        border-radius: 15px;
        margin: 0;
        padding-left: 6%;
        padding-right: 6%;

        .icon
        {
            .WidthHeight(15px);
            fill: var(--theme-accent-color);
        }
    }

    #added-stores-card
    {
        background-color: var(--theme-content-background-color);
        border-radius: 15px;
        margin-top: 2vh;
        display: flex;
        flex-flow: column;
        padding: 3vh 3vh 2vh 3vh;
        box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.05);

        height: 65vh;

        .OnTablet({
            height: 68vh;
        });

        .OnDesktop({
            height: 75vh;
        });

        #store-search-field
        {
            margin-bottom: 10px;
        }

        #store-cards
        {
            overflow-y: auto;
            overflow-x: hidden;
            -webkit-overflow-scrolling: touch;

            .store-card
            {
                display: flex;
                flex-direction: line;
                align-items: center;
                padding: 3vw 1vw;
                cursor: pointer;

                .OnDesktop({
                    padding: 1.5vw 1vw;
                });

                .store-card-information
                {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    .store-image
                    {
                        object-fit: cover;
                        border-radius: 7px;
                        width: 17vw;
                        height: 12vw;

                        .OnTablet({
                            width: 11vw;
                            height: 8vw;
                        });

                        .OnDesktop({
                            width: 6vw;
                            height: 4vw;
                        });
                    }

                    .store-header
                    {
                        display: flex;
                        flex-direction: column;
                        margin-left: 5vw;

                        .OnTablet({ margin-left: 4vw; });
                        .OnDesktop({ margin-left: 2vw; });

                        .store-name
                        {
                            font-family: Nunito;
                            font-weight: 500;
                            font-size: 4.5vw;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            overflow: hidden;

                            .CapitalizeFirstLetter();

                            .OnTablet({
                                font-size: 3vw;
                            });

                            .OnDesktop({
                                font-size: 1vw;
                            });
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/EditStores.vue